import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RefundStatusRs } from '../../models/RefundStatusRs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public cutoffDate = new Date('2021-05-19');

  private ticketNumberSource = new BehaviorSubject('');
  ticketNumber = this.ticketNumberSource.asObservable();

  private refundStatusRsSource = new BehaviorSubject(new RefundStatusRs());
  refundStatusRs = this.refundStatusRsSource.asObservable();

  constructor() { }

  populateTicketNumber(ticketNumber: string) {
    this.ticketNumberSource.next(ticketNumber);
  }

  populateRefundStatusRs(refundStatusRs: RefundStatusRs) {
    this.refundStatusRsSource.next(refundStatusRs);
  }

  public isBeforeCutoffDate(refundIssueDate: Date): boolean {

    if (refundIssueDate) {
        refundIssueDate = new Date(refundIssueDate.toString().split('T')[0]);

        if (refundIssueDate && refundIssueDate < this.cutoffDate) {
        return true;
        } else if (refundIssueDate && refundIssueDate >= this.cutoffDate) {
        return false;
        }
    }

    return false;
  }
}
